export default __webpack_public_path__ + "static/media/Pretendard-SemiBold.subset.993fdcff.woff";